export const MOVABLE_CASE_PREFIX = 'c:';

export const MOVABLE_STATUS_PREFIX = 's:';

export const MOVABLE_PLACEMENT_PREFIX = 'p:';

export const MOVABLE_MOVABLE_PREFIX = 'm:';
export const MOVABLE_BOX_PREFIX = 'b:';
export const MOVABLE_OTHER_PREFIX = 'o:';
